import { render, staticRenderFns } from "./autocoplete.vue?vue&type=template&id=63c1de45&"
import script from "./autocomplete.js?vue&type=script&lang=js&"
export * from "./autocomplete.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports